import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.css'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import autobind from 'autobind-decorator'
import Button from 'orionsoft-parts/lib/components/Button'
import SecuritySatModal from 'App/components/SecuritySatModal'
import {withRouter} from 'react-router'

@withMutation(gql`
  mutation securitySatDocument($preparationId: ID, $icam: Boolean, $cto: Boolean) {
    securitySatDocument(preparationId: $preparationId, icam: $icam, cto: $cto) {
      _id
    }
  }
`)
@withMessage
@withRouter
export default class CreateDocument extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    showMessage: PropTypes.func,
    preparationId: PropTypes.string,
    securitySatDocument: PropTypes.func
  }

  state = {}

  @autobind
  async create(icam, cto) {
    const {preparationId} = this.props
    this.setState({loading: true, errorMessages: null})
    try {
      const {securitySatDocument: {_id: documentId}} = await this.props.securitySatDocument({
        preparationId: preparationId,
        icam: icam,
        cto: cto
      })
      console.log(documentId)
      this.props.router.push(`/documents/${documentId}`)
      this.props.showMessage('Se ha creado el documento satisfactoriamente!')
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, {level: 'error'})
    }
    this.setState({loading: false})
  }

  renderAlert() {
    return <SecuritySatModal onClick={(icam, cto) => this.create(icam, cto)} ref="alert" />
  }

  render() {
    return (
      <div className={styles.container}>
        <div className="row">
          <div className="col-xs-12 col-sm-3">
            <div className={styles.button}>
              <Button
                className={styles.create}
                loading={this.state.loading}
                onClick={() => this.refs.alert.toggleDialog('DropModal')}
              >
                crear documento
              </Button>
            </div>
          </div>
          <div className="col-xs-12 col-sm-3">{this.renderAlert()}</div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Preparation/CreateDocument/index.js